import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'uppercase'
  }
});

export function SectionTitle({
  value,
  gutterBottom,
  style
}: {
  value: string;
  gutterBottom?: true;
  style?: React.CSSProperties;
}) {
  const classes = useStyles();
  return (
    <Typography style={style} gutterBottom={gutterBottom} className={classes.root}>
      {value}
    </Typography>
  );
}
